import(/* webpackMode: "eager" */ "/home/runner/work/dentalMap-front/dentalMap-front/node_modules/react-bootstrap/esm/Container.js")